import { z } from 'zod';

export const albumFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  description: z.string()
    .max(1000, 'La descripción debe tener máximo 1000 caracteres')
    .optional()
    .or(z.literal('')),
  is_active: z.boolean().default(true),
});

export type AlbumFormData = z.infer<typeof albumFormSchema>;
